import {h, Fragment} from "preact"
export default function RadioButton({ value, selected, onChange, className, name, label }) {
    return (
        <label className={`ns-radio ns-color-black ns-d-flex ns-align-items-end ${className}`} for={value}>
            <input type="radio" checked={selected} onChange={onChange} name={name} id={value} value={value} />
            <span className="ns-mx-xs-1">{label}</span>
            <span className="ns-checkmark" />
        </label>
    )
}
